import React, { Fragment, useEffect, useState } from 'react'
import SelectDropdown from '../../UI/SelectDropdown';
import closeIcon from '../../images/icons/close_icon.svg';
import { connect } from 'react-redux';
import { closeOrderPopUp } from '../../action/hCommerce2';
import Camera from './Camera';
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';
import { withTranslation } from 'react-i18next';
import { CMSPath } from '../../../config/constant';

const AccompanyingGuestDetailsInput = (props) => {

    const { t } = props;
    const [accompanyGuests, setAccompanyGuests] = useState(props.guestList)
    const [showList, setShowList] = useState(false)
    const [showlistID, setShowListId] = useState(Number)
    const listData = ["Mr.", "Mrs.", "Ms.", "Dr.", "Miss"]

    React.useEffect(() => {
        console.log("this is what you are looking for " + props.guestList)

        if(props.accompanyGuests.length > 0){
            setAccompanyGuests(props.accompanyGuests.map(guest => ({ profileId: guest.profileId, nameTitle: guest.nameTitle || "", firstName: guest.firstName || guest.name3, lastName: guest.lastName || guest.name1 })));
        }

        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
        const checkin_companion_guest_event_sent = localStorage.getItem("checkin_companion_guest_event_sent")
        if(!checkin_companion_guest_event_sent)
        props.sendAnalytics(
            null, // as no guesdetails in logout state 
            props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "COMPANION DETAILS", 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "COMPANION DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")},
            0, 
            false, // guest is not logged in
            () => localStorage.setItem("checkin_companion_guest_event_sent", true)
        );
    }, [])


    const handleAccompanyGuest = (index, value, key) => {
        setAccompanyGuests(
            accompanyGuests.map((guest, i) => {
                if (i === index) {
                    return { ...guest, [key]: value };
                }
                return guest;
            })
        );
    }

    const handleGuestDetailsNext = () => {
        let nextStep = true;
        accompanyGuests.forEach((guest) => {
            if (guest.nameTitle == "" || guest.firstName == "" || guest.lastName == "") {
                props.closeOrderPopUp(true, "Please enter all the fields to proceed", "", true)
                nextStep = false;
            }
        })

        if(nextStep){
            props.setAccompanyGuestData(accompanyGuests)
            console.log("Setting Accompaning Guest" + JSON.stringify(accompanyGuests))
            props.next()
        }
    }

    return (
        <Fragment>
            <div className="main-container" style={{ background: "url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat", backgroundSize: "cover", backgroundAttachment: "fixed" }}>
                <header className="inner-pages w-footer subpages">
                    <a onClick={props.back} className="button-back"></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${props.logo}`} />
                        </div>
                        {/* <p className="bold">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section className="widgets padding-0 margin-0 container-bg">

                <div class="widget-header widget-header-checkin-inner">
                    { props.currentWidgetObj.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                </div>

                    <div className="widgets">
                        <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                            <h2>Companion details</h2>
                        </div>
                        <div className="form-window">
                            <div className="form-window-heading">
                                Enter Companion Details
                            </div>
                            {accompanyGuests.map((guest, index) => {
                                return <div key={index} className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1 seperator" style={{ borderColor: "ccc" }}>
                                    <div className="form-row margin-bottom-2">
                                        <label>Salutation</label>
                                        <div className="custom-select align-left" >
                                            <div className="select-selected" onClick={() => {setShowList(!showList); setShowListId(index)}}>{accompanyGuests[index]['nameTitle'] !== "" ? accompanyGuests[index]['nameTitle'] : "Please Select"}</div>
                                            { showList && (showlistID == index) && <div className="select-items">
                                                {listData.map((item) => {
                                                    return (
                                                        <div onClick={() => {handleAccompanyGuest(index, item, "nameTitle"); setShowList(false)} }>{item}</div>
                                                    )
                                                })}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="form-row margin-bottom-1">
                                        <label for="guestName">First Name</label>
                                        <input name="guestName" id="companionFName" type="text" onChange={(e) => handleAccompanyGuest(index, e.target.value, "firstName")} value={accompanyGuests[index]['firstName']} />
                                    </div>
                                    <div className="form-row margin-bottom-1">
                                        <label for="guestName">Last Name</label>
                                        <input name="guestName" id="companionLName" type="text" onChange={(e) => handleAccompanyGuest(index, e.target.value, "lastName")} value={accompanyGuests[index]['lastName']} />
                                    </div>
                                </div>
                            })}
                            <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <div className="form-controls">
                                    <button onClick={handleGuestDetailsNext} className="primary w-100 margin-bottom-1">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.precheckin') : t('check_in.checkin')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        cardChecksData: state.store2.cardChecksData,
        guestDetail: state.store.home.guestDetails,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        accompanyGuests: state.store2.accompanyGuests,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}
export default connect(
    mapStateToProps,
    {
        closeOrderPopUp,
        sendAnalytics
    }
)(withTranslation('translations')(AccompanyingGuestDetailsInput));